export function findScrollableChild(
  root?: HTMLElement | null,
): HTMLElement | null {
  // @ts-ignore
  if (typeof window === 'undefined') {
    throw Error('web only function')
  }
  if (!root) return null
  // @ts-expect-error
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
    acceptNode(node: HTMLElement) {
      // @ts-expect-error
      const style = getComputedStyle(node)
      if (style.overflowY === 'auto' || style.overflowY === 'scroll') {
        // @ts-expect-error
        return NodeFilter.FILTER_ACCEPT
      }
      // @ts-expect-error
      return NodeFilter.FILTER_SKIP
    },
  })

  return walker.nextNode() as HTMLElement | null
}
